import { useEffect, useRef } from "react"
import { Modal } from "bootstrap"
import EditProductForm from "./EditProductForm"

function EditProductModal({ categories, setUpdated, currentProduct }) {
  const modalRef = useRef(null)
  const modalInstance = useRef(null)

  useEffect(() => {
    if (modalRef.current) {
      modalInstance.current = new Modal(modalRef.current)
    }
  }, [])

  /* =========================
     CLEANUP ON UNMOUNT
  ========================= */
  useEffect(() => {
    return () => {
      document.body.classList.remove("modal-open")
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    }
  }, [])

  /* =========================
     HANDLE CLOSE
  ========================= */
  const handleClose = () => {
    if (modalInstance.current) {
      modalInstance.current.hide()
    }

    // 🔥 force cleanup (important)
    setTimeout(() => {
      document.body.classList.remove("modal-open")
      document.querySelectorAll(".modal-backdrop").forEach((el) => el.remove())
    }, 300)
  }

  return (
    <div
      ref={modalRef}
      className="modal fade"
      id="editProductModal"
      tabIndex="-1"
      aria-labelledby="editProductModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-fullscreen-xl-down modal-xl">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-3">Edit Product</h1>

            {/* ❌ REMOVE data-bs-dismiss */}
            <button type="button" className="btn-close" onClick={handleClose} />
          </div>

          <div className="modal-body">
            <div className="container-fluid">
              {currentProduct ? (
                <EditProductForm
                  categories={categories}
                  setUpdated={setUpdated}
                  currentProduct={currentProduct}
                />
              ) : (
                <div className="text-center py-5">Loading...</div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditProductModal
